import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga4';
import { jss, ThemeProvider } from 'react-jss';
import preset from 'jss-preset-default';
import { toast } from 'react-toastify';

import { ApolloProvider } from 'react-apollo';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import 'mapbox-gl/dist/mapbox-gl.css';
import 'react-toastify/dist/ReactToastify.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-vis/dist/style.css';
import 'react-day-picker/lib/style.css';
import 'assets/icons/dosh-favicon.png';

import App from 'components/App';
import { theme, jssGlobal, client, sentryInit } from './config';
import { UserMgmtProvider } from 'components/UserMgmt/UserMgmt.context';

sentryInit();
toast.configure();
jss.setup(preset());
// TODO: Check deeply why react-jss ignores global when used within React TypeScript.
// https://github.com/cssinjs/react-jss/issues/238
jss.createStyleSheet(jssGlobal).attach();

ReactGA.initialize([
  {
    trackingId: process.env.GA_TRACKING_ID ?? '',
    gaOptions: {
      siteSpeedSampleRate: 100,
    },
  },
]);
ReactGA.set({ page: 'Merchant-Portal-Home' });

ReactDOM.render(
  <ApolloProvider client={client}>
    <ThemeProvider theme={theme}>
      <IntlProvider locale="en" defaultLocale="en" timeZone="America/Chicago">
        <Router>
          <UserMgmtProvider>
            <App />
          </UserMgmtProvider>
        </Router>
      </IntlProvider>
    </ThemeProvider>
  </ApolloProvider>,
  document.getElementById('app'),
);
